// The 3-column field. PLAN.md §2, §7.2.
// We don't use Rondo's <ThreeColumnLayout> directly — it's tuned for landing/
// discovery with center vertical alignment. Trading Grounds wants the cells
// edge-to-edge across the viewport, so we use a tighter custom grid here.

import { ShortsColumn } from './ShortsColumn.js'
import { LongsColumn } from './LongsColumn.js'
import { SpectatorColumn } from '../Spectator/SpectatorColumn.js'

export function Field() {
  return (
    <div className="grid grid-cols-3 gap-6 px-6 py-4 h-[calc(100vh-3.5rem)]">
      <ShortsColumn />
      <SpectatorColumn />
      <LongsColumn />
    </div>
  )
}
